import React, { useEffect, useState } from 'react';
import { Form } from 'antd';

import FormItem from '@/components/ui/FormItem';
import { DollarSignIcon } from '@/assets/icons/dollar-sign';

import * as S from './styles';

const { useFormInstance } = Form;

export function InvestmentRangeFormItem(): JSX.Element {
	const form = useFormInstance();
	const [investmentRange, setInvestmentRange] = useState<number>(0);

	function handleOnClick(value: number): void {
		setInvestmentRange(value);
		form.setFieldValue('investment_range', value);
	}

	function getCharacters(index: number): JSX.Element[] {
		const repetitions = index + 1;
		return Array.from({ length: repetitions }, (_, i) => <DollarSignIcon key={i} width={20} height={20} />);
	}

	useEffect(() => {
		setInvestmentRange(form.getFieldValue('investment_range'));
		return () => {
			form.setFieldValue('investment_range', 0);
			setInvestmentRange(0);
		};
	}, []);

	return (
		<FormItem name="investment_range">
			<S.Group>
				<S.RateWrapper
					count={3}
					value={investmentRange}
					onChange={handleOnClick}
					character={({ index }) => <S.RateButton key={index}>{getCharacters(index ?? 0)}</S.RateButton>}
				/>
			</S.Group>
		</FormItem>
	);
}
